import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IEstelamBimehMarkaziByPleakQuery } from '../Queries/IEstelamBimehMarkaziByPleakQuery';

export const getEstelamBimehMarkaziByPleak = createAsyncThunk(
  'BimehNameh/estelamBimehMarkaziByPelak',
  async (query: IEstelamBimehMarkaziByPleakQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehMarkazi.EstelamBimehNamehDetailWithShomarehEntezami}`,
      params: query,
    });
  }
);
